/**
 * @fileoverview Unread notification count query hook.
 * @description Wraps getUnreadNotificationCount in a React Query query so the bell badge shows the
 * exact unread total rather than a count of the first page of GET /notifications.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useQuery } from '@tanstack/react-query'

import { getUnreadNotificationCount } from '@/features/notifications/services/notifications.service'

export const NOTIFICATION_UNREAD_COUNT_QUERY_KEY = ['notifications', 'unread-count']

/**
 * @description Fetches the signed-in user's unread notification count.
 * @returns {import('@tanstack/react-query').UseQueryResult<number>} The query result.
 */
export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
    queryFn: getUnreadNotificationCount,
  })
}
